/* Chromeo - per-image auto-crop for product galleries.
 *
 * WHY: the product PNGs are square canvases with the artwork centered and a
 * transparent margin around it. That margin varies wildly - 1.7% on one sticker
 * image to 35% on another, and it differs between images inside a single
 * product - so no single CSS aspect-ratio can fit them. This measures each
 * image's real content bounds and sizes that image's frame to match.
 *
 * SAFETY: only ever removes fully transparent pixels, so artwork is never
 * clipped. Two hard gates: the source must be a SQUARE canvas, and its corner
 * pixel must be transparent. Photos on a solid background are left alone -
 * their background is part of the shot, not padding.
 *
 * If this script fails or is blocked, frames simply stay square. Graceful.
 */
(function(){
'use strict';
var PAD = 0.015;   // keep 1.5% breathing room; also absorbs sampling error
var MIN = 0.03;    // skip if there's less than 3% total to reclaim
var PROBE = 120;   // sample size - 1px ~= 0.83%, well under PAD

function measure(src){
  var probe = src.split('?')[0].replace(/(\\.[a-z0-9]+)$/i, '_' + PROBE + 'x$1');
  return fetch(probe).then(function(r){ return r.blob(); }).then(createImageBitmap).then(function(bm){
    if (bm.width !== bm.height) return null;              // gate 1: square only
    var c = new OffscreenCanvas(bm.width, bm.height);
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(bm, 0, 0);
    var d = x.getImageData(0, 0, c.width, c.height).data;
    if (d[3] >= 12) return null;                          // gate 2: transparent bg only
    var H = c.height, W = c.width, y, xx, hit, top = -1, bot = -1;
    for (y = 0; y < H; y++) {
      hit = false;
      for (xx = 0; xx < W; xx++) { if (d[(y * W + xx) * 4 + 3] > 12) { hit = true; break; } }
      if (hit) { top = y; break; }
    }
    if (top < 0) return null;                             // fully transparent
    for (y = H - 1; y >= 0; y--) {
      hit = false;
      for (xx = 0; xx < W; xx++) { if (d[(y * W + xx) * 4 + 3] > 12) { hit = true; break; } }
      if (hit) { bot = y; break; }
    }
    return { top: top / H, bot: (H - 1 - bot) / H };
  });
}

function apply(item){
  if (item.__czCrop) return; item.__czCrop = true;
  var img = item.querySelector('img'); if (!img) return;
  var box = item.querySelector('.product__media') || item.querySelector('.media'); if (!box) return;
  var src = img.currentSrc || img.src; if (!src) return;

  measure(src).then(function(m){
    if (!m) return;
    var top = Math.max(0, m.top - PAD);
    var bot = Math.max(0, m.bot - PAD);
    if (top + bot < MIN) return;                          // not worth a reflow
    var frac = 1 - top - bot;                             // visible slice of the square
    // square image at width:100% renders height == container width, so a
    // translateY in % of the image's own height shifts by exactly top * width.
    box.style.setProperty('padding-top', '0', 'important');
    box.style.setProperty('padding-bottom', '0', 'important');
    box.style.setProperty('height', 'auto', 'important');
    box.style.setProperty('aspect-ratio', String(1 / frac), 'important');
    box.style.setProperty('overflow', 'hidden', 'important');
    box.style.setProperty('position', 'relative', 'important');
    img.style.setProperty('position', 'absolute', 'important');
    img.style.setProperty('left', '0', 'important');
    img.style.setProperty('top', '0', 'important');
    img.style.setProperty('width', '100%', 'important');
    img.style.setProperty('height', 'auto', 'important');
    img.style.setProperty('object-fit', 'fill', 'important');
    img.style.setProperty('transform', 'translateY(' + (-top * 100).toFixed(3) + '%)', 'important');
    item.setAttribute('data-cz-cropped', (top * 100).toFixed(1) + '/' + (bot * 100).toFixed(1));
  }).catch(function(){ /* leave the frame square */ });
}

function run(){
  var items = document.querySelectorAll('.product__media-list .product__media-item');
  for (var i = 0; i < items.length; i++) apply(items[i]);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
else run();
document.addEventListener('shopify:section:load', run);
})();